// Everything exported here, both the getZ return and officeZ, is now injected
// into CSS as variables suffixed with "Z". For example, this file has
// trainerBackground: -10, so in CSS you can do var(--trainerBackgroundZ), and
// it will get substituted with -10. The machinery for this is in build/css.js.

//Every html element with a set z-index should get their z-index from here.
//Things with z-index set in CSS should be noted here for reference.
module.exports = {
	trainerBackground: -10, //In css
	trainerBackgroundJazz: -9, //In css
	pageTabControl: -3,
	pageBackground: -2, //In css (CoreGeneral .pageArgyle)
	engineBackgroundBottom: -1, //In css (.engine TrainerPageWrapper)
	chapterTray: -1,
	jazz: -1, //In css TrainerJazz
	hidden: -1,
	engineBackground: -1, //In css
	loginFormBackground: -1, //In css
	beastBuildArea: -1,
	topBarDropdown: -1, //In css
	summaryJazzOver: "0",
	trainerBorder: "0", //In css, needs to be less than tools
	profileEditButton: 1, //in css
	topBarHoverArea: 1, //In css
	summaryBeast: 1,
	problemSetProgress: 1,
	problemTestProgress: 1,
	problemTrophyProgress: 1, //In css
	profileLegendEnd: 1,
	beastPartInactive: 1,
	blockStars: 1, //In css
	beastPartActive: 1,
	chapterPageBackdrop: 1, //in css
	titleBar: 2,
	summaryBeastContainer: 2,
	progressButtons: 2, //in css SetProgressStandard
	progressStar: 2,
	profileLegendMiddle: 2,
	chapterBar: 2, //in css
	keyboard: 2,
	drawvas: 2, //in css Drawvas
	progressButton: 3,
	tools: 3, //In css, ToolGeneral
	tooltrays: 3,
	beastBuilderSelectAll: 3, // TODO: this obscures parts, seems wrong
	//beast-build-color-bar-wrapper: 4 //in css
	iconButton: 4,
	starProgress: 4,
	blueButton: 4, //in css WonkyButton
	instructions: 5,
	registerGetMore: 5,
	autosuggestions: 5, //In css
	devSubmitButtons: 5, //In css
	bookModal: 5,
	videoModal: 5,
	teacherModal: 6,
	showProblemDraggable: 6,
	messageSliders: 7,
	beastBuilderNavButtons: 12,
	partShopBackdrop: 99,
	partShopTabInactive: 100,
	partShop: 103,
	partShopTabActive: 103,
	beastMovableBorder: 105,
	modalBackdropMessage: 199,
	underTopBar: 199,
	topBar: 200,
	aboveTopBar: 201,
	demoBar: 202,
	aboveDemoBar: 203,
	tooltip: 301,
	tooltipIcon: 302,
	copyright: 350, //In css MainTrainerContainer
	belowGlobalModal: 500,
	globalModal: 501,
	aboveModalBackdrop: 600, // Needs to be above the top bar
	aboveModal: 700,
	devTools: 1000000, //In css DevDebugMenu

	// stuff below was formerly officeZ
	faqBubble: 2,
	bar: 100, //Top & Bottom bars in css
	bgBrand: 100, //in css
	flag: 101,
	dropdownSelect: 101,
	topBarMenu: 102, //in css
	overBarModalBackdrop: 150,
	overBarModal: 151,
	//Used for modals that need to go above normal overBar modals:
	warningModalBackdrop: 200,
	warningModal: 201,
	browserModal: 500,

	privacyAlert: 800,

	// CHAPTER PATH
	chapterPathBackgroundLandscape: "0", //no.  don't ask me.
	chapterPathBackgroundRoofline: 1,
	chapterPathBackgroundHall: 2,
	chapterPathBuilding: 3,
	chapterPathRoom: 4,
	chapterPathStaircase: 5,
	chapterPathDottedPathStaircase: 6,
	chapterPathDottedPath: 7,
	chapterPathButton: 8,
	chapterPathAvatar: 9,
	chapterPathLessonPrompt: 10,
};
//TODO: home page z-indices not in here yet.
